import { PatientProfile } from '@/lib/apis/types'
import clsx from 'clsx'
import { GENDERS } from '@/lib/types'

type Props = {
  values: PatientProfile
}

export default function PersonalInformationReviewList({ values }: Props) {
  const classes = clsx('col-span-full grid grid-cols-6 gap-y-4')

  return (
    <>
      <div className={classes}>
        <div className="col-span-6 flex flex-col sm:col-span-3">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            First name
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.firstName}
          </dd>
        </div>
        <div className="col-span-6 flex flex-col sm:col-span-3">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Last name
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.lastName}
          </dd>
        </div>
      </div>
      {values.gender && (
        <div className={classes}>
          <div className="col-span-6 flex flex-col">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Gender
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-700">
              {values.gender ? GENDERS[values.gender as 'M' | 'F'] : ''}
            </dd>
          </div>
        </div>
      )}
      <div className={classes}>
        <div className="col-span-6 flex flex-col sm:col-span-3">
          <dt className="text-sm font-medium leading-6 text-gray-900">Email</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.email}
          </dd>
        </div>
        <div className="col-span-6 flex flex-col sm:col-span-3">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Mobile
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.mobile}
          </dd>
        </div>
      </div>
      <div className={classes}>
        <div className="col-span-6 flex flex-col">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Date of birth
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">{values.dob}</dd>
        </div>
      </div>
      <div className={classes}>
        <div className="col-span-6 flex flex-col">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Address
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.formattedAddress}
          </dd>
        </div>
      </div>
      <div className={classes}>
        <div className="col-span-2 flex flex-col">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Suburb
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.suburb}
          </dd>
        </div>
        <div className="col-span-2 flex flex-col">
          <dt className="text-sm font-medium leading-6 text-gray-900">State</dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.state}
          </dd>
        </div>
        <div className="col-span-2 flex flex-col">
          <dt className="text-sm font-medium leading-6 text-gray-900">
            Postcode
          </dt>
          <dd className="mt-1 text-sm leading-6 text-gray-700">
            {values.postcode}
          </dd>
        </div>
      </div>
    </>
  )
}
